export default __webpack_public_path__ + "static/media/6_bees_icon.ae7025eb.png";